// extracted by mini-css-extract-plugin
export default {"container":"checkBox_container__Pm9Q9","checkmark":"checkBox_checkmark__b8Gw3"};